import { createSlice } from "@reduxjs/toolkit";

// Temas de evaluacion: el catalogo jerarquico de temas.
const initialState = {
    defaultEntity: {
        id: 0,
        nombre: "",
        descripcion: "",
        idTemaPadre: 0,
        orden: 0,
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    entity: {
        id: 0,
        nombre: "",
        descripcion: "",
        idTemaPadre: 0,
        orden: 0,
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    listTemaPadre: [{ id: 0, descripcion: "" }],
    listEstados: [{ id: 0, descripcion: "" }],
    validationActive: {
        nombre: false,
        orden: false,
    },
    validationMessage: [],
}

export const evaluacionSlice = createSlice({
    name: "evaluacion",
    initialState,
    reducers: {
        setEntity: (state, action) => {
            state.entity = action.payload;
        },
        setData: (state, action) => {
            var { name, value } = action.payload;

            if (name.startsWith("id")) value = parseInt(value)

            state.entity[name] = value
            state.validationActive[name] = true
        },
        setListTemaPadre: (state, action) => {
            state.listTemaPadre = action.payload;
        },
        setListEstados: (state, action) => {
            state.listEstados = action.payload;
        },
        setValidationMessage: (state, action) => {
            state.validationMessage = action.payload;
        },
        activeValidations: (state, action) => {
            Object.keys(state.validationActive).forEach(function (key) {
                state.validationActive[key] = true;
            })
        },
    },
});

export const { setEntity, setData, setListTemaPadre, setListEstados
    , setValidationMessage, activeValidations } = evaluacionSlice.actions;
export default evaluacionSlice.reducer;
